export type UserPreferenceLanguage = 'en-US' | 'de-DE';

export type UserPreference = {
  id?: number;
  userId: string;
  isDarkMode: boolean;
  language: UserPreferenceLanguage;
  showHeroSection: boolean;
  createdAt?: string | null;
  createdBy?: string | null;
  changedAt?: string | null;
  changedBy?: string | null;
};

export type UserPreferenceSettings = Pick<UserPreference, 'isDarkMode' | 'language' | 'showHeroSection'>;

export const defaultPreference: UserPreferenceSettings = {
  isDarkMode: false,
  language: 'de-DE',
  showHeroSection: false,
};
